/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { BrowserRouter, Prompt } from "react-router-dom";
import { environment } from "../../environment";
import UngespeicherteAenderungenDialog from "../UngespeicherteAenderungenDialog";
import CloudBrowserRouterModel from "./CloudBrowserRouterModel";

export interface CloudBrowserRouterProps {
    children: React.ReactNode;
}

export default function CloudBrowserRouter(props: CloudBrowserRouterProps) {
    const vm = new CloudBrowserRouterModel();
    return <>
        <BrowserRouter getUserConfirmation={vm.getUserConfirmation} basename={environment.mandant}>
            {props.children}
            <Prompt message={vm.getDialogText} />
        </BrowserRouter>
        <UngespeicherteAenderungenDialog
            isOpen={vm.isOpen}
            onSchliessen={vm.schliessen}
            onSpeichern={vm.speichern}
            onVerwerfen={vm.verwerfen}
        />
    </>;
}
